import { I18n } from "react-redux-i18n";

export const tr = <T extends string>(key: T) => {
  return I18n.t(key);
};